"use client";

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from "@/components/ui/sheet";
import { categories } from "@/lib/categories";
import { ChevronRight, Menu } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Sidebar() {
  return (
    <div className="lg:hidden">
      <Sheet>
        <SheetTrigger asChild>
          <div className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-brand-light bg-white text-brand-navy transition-colors hover:border-brand-sky hover:text-brand-sky hover:bg-brand-light/40">
            <Menu size={20} />
          </div>
        </SheetTrigger>

        <SheetContent
          side="left"
          className="flex w-[320px] flex-col gap-0 overflow-y-auto p-0 scrollbar-thin scrollbar-thumb-brand-light scrollbar-track-transparent sm:w-[320px]"
        >
          <SheetHeader className="border-b border-brand-light bg-brand-light/40 px-5 py-5">
            <Link href="/">
              <Image
                src="https://ichchapuron.nyc3.cdn.digitaloceanspaces.com/ichchapuron/ichchapuron-bangla-logo.png"
                alt="ichchapuron"
                className="w-24 md:w-32"
                width={100}
                height={100}
              />
            </Link>
          </SheetHeader>

          <div className="flex-1 overflow-y-auto px-3 pb-8 pt-3 scrollbar-thin scrollbar-thumb-brand-light scrollbar-track-transparent">
            <Accordion type="single" collapsible className="w-full space-y-1">
              {categories?.map((data, index) => {
                const categoryKey = data?.id ?? `category-${index}`;

                return data?.subCategory?.length ? (
                  <AccordionItem
                    key={categoryKey}
                    value={`category-${categoryKey}`}
                    className="border-b border-brand-light last:border-b-0"
                  >
                    <AccordionTrigger className="gap-2 rounded-lg px-3 py-4 text-base font-medium capitalize text-brand-navy hover:bg-brand-light/50 hover:no-underline [&[data-state=open]]:text-brand-deep">
                      {data?.title}
                    </AccordionTrigger>

                    <AccordionContent className="pb-3">
                      <div className="flex flex-col gap-1.5 rounded-xl bg-brand-light/50 p-3">
                        {data?.subCategory?.slice(0, 10).map((item, subIndex) => (
                          <Link
                            key={item?.id ?? `subcategory-${categoryKey}-${subIndex}`}
                            href={item?.path || "/"}
                            className="group flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm capitalize text-foreground transition-colors hover:bg-white hover:text-brand-deep"
                          >
                            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-sky/40 group-hover:bg-brand-sky transition-colors" />
                            <SheetClose className="text-left">
                              {item?.name}
                              {item?.banglaName ? ` (${item.banglaName})` : ""}
                            </SheetClose>
                          </Link>
                        ))}

                        {data?.subCategory?.length > 10 && (
                          <Link
                            href="/category"
                            title="Explore Products Categories"
                            className="mt-2"
                          >
                            <SheetClose className="flex w-full cursor-pointer items-center justify-center gap-1 rounded-lg gradient-primary px-4 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-95">
                              See All Categories
                              <ChevronRight size={14} />
                            </SheetClose>
                          </Link>
                        )}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                ) : (
                  <Link
                    key={categoryKey}
                    href={data?.link || "/"}
                    className="group flex items-center justify-between border-b border-brand-light px-3 py-4 text-base font-medium capitalize text-brand-navy transition-colors last:border-b-0 hover:bg-brand-light/50 hover:text-brand-deep"
                  >
                    <SheetClose className="w-full text-left">
                      {data?.title}
                    </SheetClose>
                    <ChevronRight
                      size={16}
                      className="text-muted-foreground group-hover:text-brand-sky group-hover:translate-x-0.5 transition-all"
                    />
                  </Link>
                );
              })}
            </Accordion>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}